import { getDayEnd, getDayStart } from "@wojtekmaj/date-utils";

import Tile from "../Tile";

import {
  formatDay as defaultFormatDay,
  formatLongDate as defaultFormatLongDate,
} from "../shared/dateFormatter";
import { isWeekend } from "../shared/dates";

const className = "react-calendar__month-view__days__day";

export default function Day({
  calendarType,
  classes = [],
  currentMonthIndex,
  formatDay = defaultFormatDay,
  formatLongDate = defaultFormatLongDate,
  ...otherProps
}) {
  const { date, locale } = otherProps;

  const classesProps = [];

  if (classes) {
    classesProps.push(...classes);
  }

  if (className) {
    classesProps.push(className);
  }

  if (isWeekend(date, calendarType)) {
    classesProps.push(`${className}--weekend`);
  }

  if (date.getMonth() !== currentMonthIndex) {
    classesProps.push(`${className}--neighboringMonth`);
  }

  return (
    <Tile
      {...otherProps}
      classes={classesProps}
      formatAbbr={formatLongDate}
      maxDateTransform={getDayEnd}
      minDateTransform={getDayStart}
      view="month"
    >
      {formatDay(locale, date)}
    </Tile>
  );
}
